<template>
  <v-main>
    <section id="hero">
      <v-responsive>
      <v-parallax id="parallaxImg" :src="heroImg" height="1000">
        <v-theme-provider dark>
        <v-container fill-height>
          <v-row align="center" class="mx-auto py-auto" justify="center">
            <v-col class="white--text text-center" cols="12" tag="h1" >
                <span class="font-weight-black display-2 text-md-h3 white--text">KEN CARR</span>
                <br />
                <span class="font-weight-black display-2">for</span>
                <br />
                <span class="font-weight-black display-2 white--text">Board of Directors</span>
            </v-col>
            <v-col align="center" col="12">
            <v-btn class="align-self-end" color="accent" fab ripple dark outlined @click="$vuetify.goTo('#about-me')">
              <v-icon>mdi-chevron-double-down</v-icon>
            </v-btn>
            </v-col>
          </v-row>
          <v-row><v-spacer></v-spacer></v-row>
        </v-container>
        </v-theme-provider>
      </v-parallax>
      </v-responsive>
    </section>

    <section class="white" id="about-me">
      <div class="py-12"></div>
      <v-container class="text-center">
        <h2 class="display-2 font-weight-bold mb-3 primary_text--text">ABOUT ME</h2>

        <v-responsive class="mx-auto mb-8" width="250">
          <v-divider class="mb-1 divider"></v-divider>

          <v-divider class="divider"></v-divider>
        </v-responsive>

        <v-responsive
          class="mx-auto title font-weight-light mb-8"
          max-width="720"
        >My name is Ken Carr, and I live on Spruce Pine Court. I work as a consultant for a 
company that helps organizations create innovative strategies, operate more effectively, and deliver
effective behavioral healthcare outcomes. My wife, Deb, works at Lee Health. We have enjoyed getting
to know our neighbors, especially our “First Friday” cookouts where we grill out, share food and get to
know the neighbors on Spruce Pine.</v-responsive>

        <v-avatar class="elevation-16 mb-12" size="128">
          <v-img :src="profilePic"></v-img>
        </v-avatar>

      </v-container>

      <div class="py-12"></div>
    </section>

    <section class="white" id="experience">
      <v-sheet color="dark_primary">
      <div class="py-12"></div>
      <v-container class="text-center">
        <h2 class="display-2 font-weight-bold mb-3 white--text">Experience</h2>

        <v-responsive class="mx-auto mb-8" width="250">
          <v-divider class="mb-1 divider"></v-divider>

          <v-divider class="divider"></v-divider>
        </v-responsive>

        <v-responsive
          class="mx-auto title font-weight-light mb-8 white--text"
          max-width="720"
        >I have spent most of my career working as a Chief Financial Officer (CFO) for mission-
based organizations and maintain an active CPA certificate. My work has focused around financial
leadership, organizational strategy, board governance, and performance management. I have also
managed a broad range of administrative and operational systems including facilities acquisition, property
leases and maintenance, human resources, technology, and quality systems.</v-responsive>
      </v-container>

      <div class="py-12"></div>
      </v-sheet>
    </section>
    
    <section id="pillars" >
      
      <div class="py-12"></div>
      <v-container class="text-center">
        <h2 class="display-2 font-weight-bold mb-3 primary_text--text">Pillars of Leadership</h2>

        <v-responsive class="mx-auto mb-8" width="450" color="divider">
          <v-divider  class="mb-1 divider"></v-divider>

          <v-divider class="divider"></v-divider>
        </v-responsive>

        <v-row>
            <v-col
              v-for="({ icon, title, text }, i) in pillars"
              :key="i"
              cols="12 "
              md="3"
            >
              <v-card
                class="py-12 px-5"
                color="light_primary"
                elevation="6"
                dark
                
              >
                <v-theme-provider dark>
                  <div>
                    <v-avatar
                      color="accent"
                      size="88"
                    >
                      <v-icon
                        large
                        v-text="icon"
                        color="primary_text"
                      ></v-icon>
                    </v-avatar>
                  </div>
                </v-theme-provider>

                <v-card-title
                  class="justify-center primary_text--text text-no-wrap"
                  v-text="title"
                
                ></v-card-title>

                <v-card-text
                  class="subtitle-1 secondary_text--text"
                  v-text="text"
                >
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

      </v-container>

      <div class="py-12"></div>
      
    </section>

    <section id="calendar">
      <v-sheet color="dark_primary">
      <div class="py-12"></div>
        <v-container class="text-center">
            <h2 class="display-2 font-weight-bold mb-3 white--text">Events</h2>
            <v-responsive class="mx-auto mb-8" width="250">
              <v-divider class="mb-1 divider"></v-divider>

              <v-divider class="divider"></v-divider>
            </v-responsive>
            <v-row class="center">
              <v-col>
            <v-timeline :dense="$vuetify.breakpoint.smAndDown">
              <v-timeline-item
                v-for="(item, i) in events"
                :key="i"
                :color="item.color"
                :position="item.position"
                fill-dot
                dark
              >
              <v-card :color="item.color">
                <v-card-title class="title">{{ item.title }}</v-card-title>
                  <v-card-text class="white text--primary font-weight-bold">
                    <v-container>
                      <v-row>
                        <v-col >
                          {{ item.eventdata }}
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>
              </v-card>
            </v-timeline-item>
          </v-timeline>
              </v-col>
            </v-row>
        </v-container>
      <div class="py-12"></div>
      </v-sheet>
    </section>

    <section id="faq">
      
        <div class="py-8"></div>
          <v-container class="text-center">
            <h2 class="display-2 font-weight-bold mb-3 primary_text--text">FAQ</h2>

            <v-responsive class="mx-auto mb-8" width="250">
              <v-divider class="mb-1 divider"></v-divider>

              <v-divider class="divider"></v-divider>
            </v-responsive>
            <v-row align="center">
              <v-col>
              <v-expansion-panels
                accordion
                popout
                v-model="panel"
                multiple
              >
              <v-expansion-panel
                v-for="({ title, text }, i) in faqs"
                :key="i"
                color="light_primary primary_text--text"
              >
                  <v-expansion-panel-header color="light_primary primary_text--text"><h3>{{ title }}</h3></v-expansion-panel-header>
                  
                  <v-expansion-panel-content color="light_primary primary_text--text text--center" align="center" >
                  <p>{{ text }}</p>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                
              </v-expansion-panels>
              </v-col>
            </v-row>
          </v-container>
        <div class="py-8"></div>
      
    </section>

    <section class="white" id="photos">
      <v-sheet color="dark_primary">
        <div class="py-12"></div>
          <v-container class="text-center">
            <h2 class="display-2 font-weight-bold mb-3 white--text">Our Family</h2>

            <v-responsive class="mx-auto mb-8" width="250">
              <v-divider class="mb-1 divider"></v-divider>

              <v-divider class="divider"></v-divider>
            </v-responsive>
            <v-row class="center">
              <v-col>
                <v-card elevation="6" max-height="900">
                  <v-carousel height="75vh" >
                    <v-carousel-item
                      v-for="(item,i) in photos"
                      :key="i"
                      :src="item.src"
                    ></v-carousel-item>
                  </v-carousel>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        <div class="py-12"></div>
      </v-sheet>
    </section>

    <section id="contact">
      
      <div class="py-12"></div>
        <v-container class="text-center">
          <h2 class="display-2 font-weight-bold mb-3 primary_text--text">Contact Me</h2>
          <v-responsive class="mx-auto mb-8" width="250">
            <v-divider class="mb-1 divider"></v-divider>
            <v-divider class="divider"></v-divider>
          </v-responsive>
          <v-row align="center">
            <v-col>
          <v-card elevation="6">
            <v-container class="light_primary primary_text--text">
            <v-form class="light_primary primary_text--text" v-model="valid" :lazy-validation="lazy">
              <v-row dense>
                <v-col>
                  <v-text-field
                    v-model="contactDetails.first"
                    label="First Name"
                    :rules="nameRules"
                    placeholder="First Name"
                    filled
                    autocomplete="email"
                    color="dark_primary"
                    background-color="white"
                    required
                  ></v-text-field>
                </v-col>
                
                <v-col>
                  <v-text-field
                    v-model="contactDetails.last"
                    label="Last Name"
                    :rules="nameRules"
                    placeholder="Last Name"
                    filled
                    autocomplete
                    color="dark_primary"
                    background-color="white"
                    required
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col>
                  <v-text-field
                    v-model="contactDetails.email"
                    label="Email"
                    placeholder="Email"
                    :rules="emailRules"
                    filled
                    autocomplete="email"
                    color="dark_primary"
                    background-color="white"
                    required
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row no-gutters dense>
                <v-col>
                  <v-textarea
                    v-model="contactDetails.message"
                    auto-grow
                    :rules="nameRules"
                    filled
                    color="dark_primary"
                    placeholder="Message"
                    label="Message"
                    rows="6"
                    background-color="white"
                    required
                  ></v-textarea>
                </v-col>
              </v-row>
              <v-row no-gutters dense>
              <v-col >
                <v-alert transition="v-expand-transition" dense v-model="formResponse" :type="messageType" dismissible>
                  {{formMessage}}
                </v-alert>
              </v-col>
              </v-row>
              <v-row justify="space-around" no-gutters dense>
                <v-col>
                  <v-btn :disabled="!valid" color="success" @click="recaptcha">Submit</v-btn>
                </v-col>
              </v-row>
            </v-form>
            </v-container>
          </v-card>
            </v-col>
          </v-row>
        </v-container>
        <div class="py-12"></div>
      
    </section>
  </v-main>
</template>

<style lang="scss">
  #parallaxImg .v-parallax__content{
    background: linear-gradient(0deg, transparent, 30%, var(--v-dark_primary-base) 125%);
  }
</style>

<script>
import Vue from 'vue'
import { VueReCaptcha } from 'vue-recaptcha-v3'
Vue.use(VueReCaptcha, { siteKey: '6Ldh388ZAAAAAJjT8YLpC8sw53hsLm7UJH8c1NtW' });

export default {
  name: "HelloWorld",
  
  components: {
  },
  data: () => ({
    emailRules: [
      v => !!v || 'E-mail is required',
      v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
    ],
    type: 'month',
    nameRules: [
      v => !!v || 'Name is required',
    ],
    types: ['month', 'week', 'day', '4day'],
    mode: 'stack',
    modes: ['stack', 'column'],
    weekday: [0, 1, 2, 3, 4, 5, 6],
    weekdays: [
      { text: 'Sun - Sat', value: [0, 1, 2, 3, 4, 5, 6] },
      { text: 'Mon - Sun', value: [1, 2, 3, 4, 5, 6, 0] },
      { text: 'Mon - Fri', value: [1, 2, 3, 4, 5] },
      { text: 'Mon, Wed, Fri', value: [1, 3, 5] },
    ],
    value: '',
    formResponse: false,
    messageType: '',
    photos: [
      {
        src: require("../assets/wedding2.jpg")
      },
      {
        src: require("../assets/beach_parents.jpg")
      },
      {
        src: require("../assets/dinner.jpg")
      },
      {
        src: require("../assets/docfords.jpg")
      },
    ],
    faqs: [
      {
        title: "Do I have to be present at the meeting to vote?",
        text: "No, you can mail in your ballot. But, you do need to use an official ballot and be sure to have it arrive at the Botania Lakes office before November 10 in order to be counted."
      },
      {
        title: "Does each person in the house get a vote?",
        text: "No, there is one vote per homeowner per address"
      },
      {
        title: "I didn't get a ballot, how can I get one?",
        text: "You can get a ballot sent to you by calling or emailing the Botanica Lakes office. But please hurry, time is running out. Votes must be received at the office before November 10"
      }

    ],
    events: [
      {
        color: 'indigo lighten-2',
        icon: 'mdi-star',
        position: 'right',
        eventdata: 'October 15, 2020 7:00-8:00pm',
        title: 'Candidate Meet & Greet'
      },
      {
        color: 'indigo darken-1',
        icon: 'mdi-book-variant',
        position: 'left',
        eventdata: 'November 10, 2020, 6:00 pm',
        title: 'Annual Meeting'
      },
    ],
    formMessage: '',
    colors: ['blue', 'indigo', 'deep-purple', 'cyan', 'green', 'orange', 'grey darken-1'],
    names: ['Meeting', 'Holiday', 'PTO', 'Travel', 'Event', 'Birthday', 'Conference', 'Party'],
    heroImg: require("../assets/bl-hero-2.jpg"),
    profilePic: require("../assets/ken2.jpg"),
    pillars: [
          {
            icon: 'mdi-charity',
            title: 'Respectful Culture',
            text: "There will be always be disagreement on issues in a community this size, but the board needs to ensure an environment where information is both given and received with openness and respect. Rules are an important part of living in a community, but how we communicate is often more important to results as what we communicate.",
          },
          {
            icon: 'mdi-home-outline',
            title: 'Homeowner Input',
            text: 'It’s important to remember that board members are elected to represent homeowners. The board needs to create opportunities to listen to concerns that are important to homeowners – town halls, focus groups, or other facilitated activities. Everyone who wants to have a voice in a matter should have an opportunity to be heard. And this feedback needs to be part of a systematic process of gathering information, researching options, and implementing the best decisions that reflect the overall will of the community.',
          },
          {
            icon: 'mdi-account-group-outline',
            title: 'Community Activities',
            text: 'We build closer community ties when we interact together around fun, positive activities. The board should create both the environment and structure for more community activities (adult and family) that bring community members with like interests together. There are many homeowners with both great ideas and talent to improve social activities who only need the system and support to have impact.',
          },
          {
            icon: 'mdi-currency-usd',
            title: 'Financial Transparency',
            text: 'I want to ensure that the board leverages operating processes, financial best practices, and technology to leverage our HOA dues. Budget decisions should reflect the priorities of the community, and we should have a monthly dashboard of key metrics to keep the board and homeowners informed. The capital budget should not be under-budgeted in the short-term, or overfunded in the long-term. Contracts and capital expenditures should be tied to clear statements of work, and decisions supported by return on investment analyses. This level of oversight is necessary to ensure that our monthly dues are neither higher, nor lower than necessary based on clear guidelines. This is especially important as HOAs will face serious sustainability challenges in the post-COVID economy.',
          },
    ],
    valid: true,
    contactDetails: { email: "", message: "", first: "", last: "", token: "" },
    successMsg: false
  }),
  methods: {
    getEvents ({ start, end }) {
      const events = []

      const min = new Date(`${start.date}T00:00:00`)
      const max = new Date(`${end.date}T23:59:59`)
      const days = (max.getTime() - min.getTime()) / 86400000
      const eventCount = this.rnd(days, days + 20)

      for (let i = 0; i < eventCount; i++) {
        const allDay = this.rnd(0, 3) === 0
        const firstTimestamp = this.rnd(min.getTime(), max.getTime())
        const first = new Date(firstTimestamp - (firstTimestamp % 900000))
        const secondTimestamp = this.rnd(2, allDay ? 288 : 8) * 900000
        const second = new Date(first.getTime() + secondTimestamp)

        events.push({
          name: this.names[this.rnd(0, this.names.length - 1)],
          start: first,
          end: second,
          color: this.colors[this.rnd(0, this.colors.length - 1)],
          timed: !allDay,
        })
      }

      this.events = events
    },
    getEventColor (event) {
      return event.color
    },
    rnd (a, b) {
      return Math.floor((b - a + 1) * Math.random()) + a
    },
    async recaptcha() {
        // (optional) Wait until recaptcha has been loaded.
        await this.$recaptchaLoaded()

        // Execute reCAPTCHA with action "login".
        this.contactDetails.token = await this.$recaptcha('login')
        console.log(this.contactDetails.token)

        // Do stuff with the received token.
      await fetch("https://api.kencarrforbl.com/submit", { 
        method: 'POST',
        mode: 'cors',
        body: JSON.stringify(this.contactDetails)
        }).then((response) => {
          console.log(response)
          this.formResponse = true
          this.messageType = "success"
          this.formMessage = "Message successfully sent!"
        }).catch((err) => {
          self.serverError = getErrorMessage(err);
          //helper to get a displayable message to the user
          this.formResponse = true
          this.messageType = "error"
           this.formMessage = "Failed to send message: " + self.serverError
          function getErrorMessage(err) {
            let responseBody;
            responseBody = err.response;
            if (!responseBody) {
              responseBody = err;
            }
            else {
              responseBody = err.response.data || responseBody;
            }
            return responseBody.message || JSON.stringify(responseBody);
          }
        });
      }
    }
  };
</script>
